import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

const DashboardPanel = ({dashboardDetails}) => {
  return (
    <React.Fragment>
      <div>
        <Row>
          <Col xl={3} sm={6}>
            <Card>
              <CardBody>
                <div className="d-flex text-muted">
                  <div className="flex-shrink-0 me-3 align-self-center">
                    <div className="avatar-sm">
                      <div className="avatar-title bg-light rounded-circle text-primary font-size-20">
                        <i className="ri-admin-line"></i>
                      </div>
                    </div>
                  </div>

                  <div className="flex-grow-1 overflow-hidden">
                    <p className="mb-1">Total Users</p>
                    <h5 className="mb-3">{dashboardDetails?.total_users || 0}</h5>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col xl={3} sm={6}>
            <Card>
              <CardBody>
                <div className="d-flex">
                  <div className="flex-shrink-0 me-3 align-self-center">
                    <div className="avatar-sm">
                      <div className="avatar-title bg-light rounded-circle text-primary font-size-20">
                        <i className="ri-group-line"></i>
                      </div>
                    </div>
                  </div>

                  <div className="flex-grow-1 overflow-hidden">
                    <p className="mb-1">Total Products</p>
                    <h5 className="mb-3">{dashboardDetails?.total_products || 0}</h5>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col xl={3} sm={6}>
            <Card>
              <CardBody>
                <div className="d-flex text-muted">
                  <div className="flex-shrink-0 me-3 align-self-center">
                    <div className="avatar-sm">
                      <div className="avatar-title bg-light rounded-circle text-primary font-size-20">
                        <i className="ri-chat-quote-line"></i>
                      </div>
                    </div>
                  </div>
                  <div className="flex-grow-1 overflow-hidden">
                    <p className="mb-1">Total Quotations</p>
                    <h5 className="mb-3">{dashboardDetails?.total_quotations || 0}</h5>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};
export default DashboardPanel;
